<script setup lang="ts">
import BaseModal from '@tix/ds/components/molecules/modal/BaseModal.vue'

import { useModalStore } from './store'

const modalStore = useModalStore()
</script>

<template>
  <BaseModal
    v-for="entry in modalStore.stack"
    :key="entry.name"
    :actions="entry.actions"
    :dismissible="entry.dismissible"
    :closeable="entry.closeable"
    :describedBy="entry.describedBy"
    :name="entry.name"
    :size="entry.size"
    :title="entry.title"
    @close="entry.close"
  >
    <Suspense>
      <component :is="entry.component" v-bind="entry.props" :modal="entry" />
      <template #fallback>
        <!-- Remove this once we have a loading spinner in the design system -->
        <div class="modal-loading">
          <span class="spinner" role="status">
            <span aria-hidden="true" class="spinner-icon" />
            <span class="visually-hidden">Loading, please wait</span>
          </span>
        </div>
      </template>
    </Suspense>
  </BaseModal>
</template>

<style>
body:has(dialog[open]) {
  overflow: hidden;
}

.modal-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
}

.spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.spinner-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 2px solid transparent;
  border-top-color: var(--text-tertiary, currentColor);
  border-radius: 50%;
  animation: modal-spinner-spin 1s linear infinite;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes modal-spinner-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
